<template>
    <router-view></router-view>
    <Toast />
    <ConfirmDialog />
</template>
  
<script>
    import Toast from 'primevue/toast';
    import ConfirmDialog from 'primevue/confirmdialog';

    export default {
        name: 'App',
        components: {Toast,ConfirmDialog},
    };
</script>
  
<style>
/* Adicione seus estilos aqui */
</style>